const ROW_META = {
  movies: { key: 'movies', title: 'Popular movies', subtitle: 'Blockbusters & cult classics' },
  tv: { key: 'tv', title: 'TV series', subtitle: 'Binge-worthy shows' },
  anime: { key: 'anime', title: 'Anime', subtitle: 'Films & series' },
};

/** Normalize API or merged catalog row → home / browse card shape */
export function apiItemToBrowseCard(raw) {
  return {
    category: raw.category,
    tmdbId: raw.tmdbId,
    title: raw.displayName || raw.title || '',
    poster: raw.posterUrl || raw.poster || null,
    overview: raw.overview || '',
    genres: raw.genres || raw.genreSlugs || [],
  };
}

export function mergedCatalogToBrowseCards(items) {
  return (items || []).map(apiItemToBrowseCard);
}

export function buildHomeTabRowsFromBrowseCards(allBrowseCards) {
  const movies = allBrowseCards.filter((i) => i.category === 'movie');
  const tv = allBrowseCards.filter((i) => i.category === 'tv');
  const anime = allBrowseCards.filter((i) => i.category === 'anime_movie' || i.category === 'anime_tv');
  return {
    movies: { ...ROW_META.movies, items: movies },
    tv: { ...ROW_META.tv, items: tv },
    anime: { ...ROW_META.anime, items: anime },
  };
}

export function formatCatalogCount(n) {
  if (n == null || !Number.isFinite(Number(n))) return '—';
  const v = Number(n);
  if (v >= 1_000_000) return `${Math.round(v / 1_000_000)}M+`;
  if (v >= 10_000) return `${Math.round(v / 1000)}k+`;
  if (v >= 1000) return `${(v / 1000).toFixed(1)}k+`;
  return `${v}`;
}
